import database from '../firebase/firebase';
import {ShowNotification} from '../components/HandleNotifications';
import {setCompany} from './initializer_actions';

export const companyTypes = {
    FETCH_DATA: "company/GETTING_DATA",
    PUBLISH_DATA: "company/PUBLISHING_DATA"
};

export const saveData = (payload) => ({
    type: companyTypes.PUBLISH_DATA,
    payload
});

export const publishData = (newData = {}) => {
    return (dispatch, getState) => {
        const uid = getState().auth.uid;
        const {
            companyName = '', companyAbout = '', companyVideo = '', established = '',
            proportion = '', avAge = '', employeeCount = '', companyLogo = '',
            companyEmail = '', website = '', data = '',
            companyCulture = [{title: '', cultureLongform: '', img: ''}],
            locationName = '',
            latlang = []
        } = newData

        const payload = {
            companyName,
            companyAbout,
            companyLogo,
            companyVideo,
            established,
            avAge,
            proportion,
            employeeCount,
            website,
            data,
            companyEmail,
            locationName,
            latlang,
            companyCulture,
            objectID: uid,
            active: true
        };

        database.collection(`companies`)
            .doc(`${uid}`)
            .set(payload, {merge: true})
            .then(() => {
                dispatch(saveData(payload));
                ShowNotification('success','Guardamos tus datos con exito!', 'Todo Listo')
            })
    }
}
